// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link--JV1_s","Wrapper":"Wrapper--2gHXc","Primary":"Primary--QgGsi","Secondary":"Secondary--mFC8i"};